export default __webpack_public_path__ + "static/media/gnb-w@3x.8549a558.png";